import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {NgxModalDraggableDirective} from '../../../directives/draggable.directive';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {TelegramService} from '../../../pages/page-telegram/telegram.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import {SenderService} from '../../../services/sender.service';
import {ReplaySubject, throttleTime} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-modal-add-balance',
  templateUrl: './modal-add-balance.component.html',
  styleUrls: ['./modal-add-balance.component.scss']
})
export class ModalAddBalanceComponent implements OnInit {
  generatePayUrl$: ReplaySubject<void> = new ReplaySubject();
  public payUrl: SafeResourceUrl = 'about:blank';
  public modalDirective: NgxModalDraggableDirective;
  public amount = 1000;
  public arCurrency = ['RUB', 'USD', 'EUR', 'UAH', 'KZT'];
  public currency = 'RUB';
  public orderId: string | number;

  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }

  constructor(
    private cd: ChangeDetectorRef,
    public senderService: SenderService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public telegramService: TelegramService,
    public bsModalRef: BsModalRef,
  ) {
  }

  ngOnInit(): void {
    this.senderService.isOpenedAddBalance = true;
    this.orderId = this.senderService.account$.value?.id || this.telegramService.arProfile?.id;
    this.generatePayUrl();

    this.generatePayUrl$.pipe(debounceTime(1000)).subscribe(() => {
      this.payUrl = 'about:blank';
      this.http.get(`${this.telegramService.urlApi}/api/sender/freekassa/url/?order_id=${this.orderId}&order_amount=${this.amount}&currency=${this.currency}`).subscribe((res: { url: string }) => {
        this.payUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
        console.log('payUrl', this.payUrl);
        this.cd.detectChanges();
      });
    });
  }

  generatePayUrl(): void {
    this.generatePayUrl$.next();
  }

  resizeIframe(obj) {
    // obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px';
  }
}
